module.exports = __webpack_public_path__ + "img/arrow-right-small_w.7a34678f.svg";